import { render, staticRenderFns } from "./motor-risk.vue?vue&type=template&id=508ca9a6&"
import script from "./motor-risk.vue?vue&type=script&lang=js&"
export * from "./motor-risk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports